import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import Checkbox from '../../../../components/Checkbox';
import InputField from '../../../../components/InputField';
import { RootState } from '../../../../store/store';
import Dropdown from '../../../../components/Dropdown';
import { PaymentMethods } from '../../../../enums/enum';
import { useGetPaymentTypesQuery } from '../../../../store/apiSlices/recruitApiSlice';
import { MAX_LENGTH_OTHER_METHOD } from '../../../../constants';

const OutsideRecruiter = () => {
	const addOrUpdateRecruit = useSelector(
		(state: RootState) => state.addOrUpdateRecruit,
	);
	const paymentMethodData = useGetPaymentTypesQuery(null);
	const { getFieldProps, getFieldMeta, getFieldHelpers } = useFormikContext();

	useEffect(() => {
		if (
			getFieldProps('outside_recruiter_details.is_outside_recruiter')
				?.value === false
		) {
			getFieldHelpers('outside_recruiter_details.name').setValue('');
			getFieldHelpers(
				'outside_recruiter_details.payment_type_id',
			).setValue(null);
			getFieldHelpers('outside_recruiter_details.bps').setValue('0');
			getFieldHelpers('outside_recruiter_details.bps_months').setValue(
				'0',
			);
			getFieldHelpers('outside_recruiter_details.flat_fee').setValue(
				'$0',
			);
			getFieldHelpers('outside_recruiter_details.other_method').setValue(
				'',
			);
		}
	}, [
		getFieldProps('outside_recruiter_details.is_outside_recruiter')?.value,
	]);

	const getPaymentMode = () => {
		const paymentMode = paymentMethodData?.currentData?.value?.find(
			(e) =>
				e.id ===
				getFieldProps('outside_recruiter_details.payment_type_id')
					?.value,
		)?.value;
		switch (paymentMode) {
			case PaymentMethods.bps:
				return (
					<>
						<InputField
							name="outside_recruiter_details.bps"
							label=""
							isRequired={false}
							type="number"
							min={1}
							isNullable={true}
							placeholder="Enter bps"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>
						<p className="whitespace-nowrap">Bps, for</p>
						<InputField
							name="outside_recruiter_details.bps_months"
							label=""
							isRequired={false}
							type="number"
							min={1}
							isNullable={true}
							placeholder="Enter months"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>
						<p>Months</p>
					</>
				);
			case PaymentMethods.flatFee:
				return (
					<>
						<p>Flat fee of</p>
						<InputField
							name="outside_recruiter_details.flat_fee"
							label=""
							isRequired={false}
							currency={true}
							min={1}
							isNullable={true}
							labelClassName="flex-grow"
							placeholder="Enter Flat fee"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>
					</>
				);
			case PaymentMethods.other:
				return (
					<>
						<p>Other</p>
						<InputField
							name="outside_recruiter_details.other_method"
							label=""
							isRequired={false}
							placeholder="Enter other"
							labelClassName="flex-grow"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
							maxLength={MAX_LENGTH_OTHER_METHOD}
						/>
					</>
				);
		}
	};

	return (
		<div className="flex flex-col bg-white p-4 gap-y-4 rounded-lg">
			<div className="text-xl font-bold">Outside Recruiter</div>
			<Checkbox
				label="Recruiter used"
				name="outside_recruiter_details.is_outside_recruiter"
				disabled={addOrUpdateRecruit.isRecruitFieldsDisabled}
			/>
			{getFieldProps('outside_recruiter_details.is_outside_recruiter')
				?.value ? (
				<>
					<div className="grid grid-cols-2 gap-4">
						<InputField
							name="outside_recruiter_details.name"
							label="Name"
							placeholder="Enter Name"
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>
						<Dropdown
							label="Payment Method"
							name="outside_recruiter_details.payment_type_id"
							placeholder="Select Payment"
							list={paymentMethodData.currentData?.value || []}
							disabled={
								addOrUpdateRecruit.isRecruitFieldsDisabled
							}
						/>
					</div>

					{getFieldProps('outside_recruiter_details.payment_type_id')
						.value ? (
						<div className="flex justify-between p-2 gap-2 bg-rcrm-primary-border-blue items-center">
							{getPaymentMode()}
						</div>
					) : null}
				</>
			) : null}
		</div>
	);
};
export default OutsideRecruiter;
